import {EmbedCodeExtractor} from "./types"

// Sample Instagram embed code:
// <blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/reel/DGDjpTOiLqw/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" ...>
//
// [^>]*? (deliberate deviation from the Ruby port's `.*`): the class and permalink are
// attributes of the SAME opening tag, so the pattern is scoped to it — this both
// accepts line-wrapped embed codes (newlines between attributes; the Ruby-parity `.`
// returned null for them, so the client fell back to the raw ~7 KB snippet and hit
// the CDN URL-length quota — Codex P2 on PR #789) and refuses to stitch the permalink
// from a different element than the instagram-media one (unlike the original `.`,
// which matched cross-element on a single line — AWS finding on PR #789).
const INSTAGRAM_EMBED_PATTERN = /class=["']instagram-media["'][^>]*?data-instgrm-permalink=["'](https?:\/\/(?:www\.)?(?:instagram\.com|instagr\.am)\/(?:p|reel)\/[a-zA-Z0-9\-_]+\/[^"']+)['"]/i

/**
 * Port of Tik::WebEmbedService::PreProcessor::Instagram (pre_processor/instagram.rb):
 * extracts the Instagram URL from blockquote embed codes and decodes HTML entities.
 */
export const instagramPreProcessor: EmbedCodeExtractor = (input: string) => {
  const match = INSTAGRAM_EMBED_PATTERN.exec(input)
  if(match === null) return null
  // Extract the Instagram URL from the matches and decode HTML entities
  return match[1].replaceAll("&amp;", "&")
}
